import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import { Link } from 'react-router-dom'
import { startGoogleLogin, startLoginEmailPassword } from '../../actions/auth'
import { useForm } from '../../hooks/mis-custom-hooks/useForm/useForm'

export const LoginScreen = () => {
    const {loading} = useSelector(state => state.ui)
    
    
    const dispatch = useDispatch()    
    const [formValues, handleInputChange] = useForm({
        email: 'jesus20.11@hotmail.es',
        password: 'rebules1'
    });

    const {email, password} = formValues
    
    const handleLogin = (e) =>{
        e.preventDefault();
        dispatch(startLoginEmailPassword(email,password))
        
    }
    const handleGoogleLogin = () =>{
        dispatch(startGoogleLogin())
    }

    return (
        <>
            <h3 className="auth__title">Login</h3>
            <form 
            onSubmit={handleLogin} 
            className="ld ld-fade-in"
            style={{ animationDuration: '0.2s' }}
            
            >
                <input
                    type="text"
                    placeholder="Email"
                    name="email"
                    className="auth__input"
                    autoComplete="off"
                    values={email}
                    onChange={handleInputChange}
                />
                <input
                    type="password"
                    placeholder="*******"
                    name="password"
                    className="auth__input"
                    values={password}
                    onChange={handleInputChange}
                />

                <button className="btn btn-primary btn-block" disabled={loading}>Login</button>

                <div className="auth__social-networks">
                    <p>
                        Login width social networks
                    </p>

                    <div className="google-btn"
                    onClick={handleGoogleLogin}>
                        <div className="google-icon-wrapper">
                            <img className="google-icon" src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" alt="google button" />
                        </div>
                        <p className="btn-text">
                            <b>Sign in with google</b>
                        </p>
                    </div>

                </div>

                <Link to="/auth/register" className="link">
                    Create new account
                </Link>

            </form>
        </>
    )
}
